import {RouteDefinition} from '../../routes';
import {UserSettingsRoutes} from './User';
import {UartSettingsRoutes} from './Uart';
import {CustomizationSettingsRoutes} from './Customization';
import {SensorSettingsRoutes} from './Sensor';
import {DeviceSettingsRoutes} from './Device';
import {GatewaySettingsRoutes} from './Gateway';
import {CameraSettingsRoutes} from './Camera';
import {ControlSettingsRoutes} from './Control';
import {IntercomSettingsRoutes} from './Intercom';
import {DoorSettingsRoutes} from './Door';
import {FloorsAndRoomsSettingsRoutes} from './FloorsAndRooms';
import {MediaSettingsRoutes} from './Media';
import {AlarmSettingsRoutes} from './Alarm';
import {HomepageSettingsRoutes} from './Homepage';
import {WiFiSettingsRoutes} from './Gateway/WiFi';
import {SoundSettingsRoutes} from './Sound';
import {LanguageSettingsRoutes} from './Language';
import {TimeSettingsRoutes} from './Time';
import {DatabaseSettingsRoutes} from './Database';
import {SystemInfoSettingsRoutes} from './SystemInfo';
import {VirtualControlSettingsRoutes} from './VirtualControl';
import {DoorBrandSettingsRoutes} from './DoorBrand';
import {InputSettingsRoutes} from './Input';
import {DeveloperSettingsScreen} from '../SettingsScreen/DeveloperSettingsScreen';
import {ControlTypeSettingsRoutes} from './ControlType';
import {BridgeDeviceTypeSettingsRoutes} from './BridgeDeviceType';
import {CameraBrandSettingsRoutes} from './CameraBrand';
import {InputTypeSettingsRoutes} from './InputType';
import {TestScreen} from './TestScreen';
import {ServerSettingsRoutes} from './Server';
import {SetDateTimeRoutes} from './SetDateTime';
import {LeftMenuSettingsRoutes} from './LeftMenu';
import {GatewayControlRoutes} from './Gateway/GatewayControl';
import {STPEditorRoutes} from './STPEditor';
import {SettingsLoginRoutes} from './SettingsLogin';
import {ConciergeSettingsRoutes} from './Concierge';
import {IftttSettingsRoutes} from "./IfDo";
import {LogsRoutes} from './Logs';
import {ProjectInfoRoutes} from './ProjectInfo';
import {EnergyPageSettingsRoutes} from './EnergyPage';
import { MultipleTemperatureRoutes } from './MultipleTemperatureScreen';
import { AdvancedMenuSettingsRoutes } from './AdvancedSettings';
import { AuthorityGroupRoutes } from './AuthorizationGroup';
import { SIPFormatRoutes } from './SIPFormatTypes';

export const DEVELOPER_URL = '/developer';
export const SettingsRoutes: RouteDefinition[] = [
    ...UserSettingsRoutes,
    ...FloorsAndRoomsSettingsRoutes,
    ...GatewaySettingsRoutes,
    ...DeviceSettingsRoutes,
    ...SensorSettingsRoutes,
    ...MediaSettingsRoutes,
    ...IntercomSettingsRoutes,
    ...CameraSettingsRoutes,
    ...AlarmSettingsRoutes,
    ...HomepageSettingsRoutes,
    ...WiFiSettingsRoutes,
    ...SoundSettingsRoutes,
    ...LanguageSettingsRoutes,
    ...CustomizationSettingsRoutes,
    ...TimeSettingsRoutes,
    ...DatabaseSettingsRoutes,
    ...SetDateTimeRoutes,
    ...SystemInfoSettingsRoutes,
    ...ControlSettingsRoutes,
    ...VirtualControlSettingsRoutes,
    ...InputSettingsRoutes,
    ...DoorSettingsRoutes,
    ...ServerSettingsRoutes,
    ...LeftMenuSettingsRoutes,
    ...STPEditorRoutes,
    ...SettingsLoginRoutes,
    ...SIPFormatRoutes,
    ...DoorBrandSettingsRoutes,
    ...ControlTypeSettingsRoutes,
    ...BridgeDeviceTypeSettingsRoutes,
    ...CameraBrandSettingsRoutes,
    ...InputTypeSettingsRoutes,
    ...UartSettingsRoutes,
    ...GatewayControlRoutes,
    ...ConciergeSettingsRoutes,
    ...IftttSettingsRoutes,
    ...LogsRoutes,
    ...ProjectInfoRoutes,
    ...EnergyPageSettingsRoutes,
    ...MultipleTemperatureRoutes,
    ...AdvancedMenuSettingsRoutes,
    ...AuthorityGroupRoutes,
    {
        routerLink: DEVELOPER_URL,
        component: DeveloperSettingsScreen,
    },
    {
        routerLink: '/developer/test',
        component: TestScreen,
    },
];
